export const START_UPDATE_CONTACT_NOTES = 'START_UPDATE_CONTACT_NOTES'
export const SUCCESS_UPDATE_CONTACT_NOTES = 'SUCCESS_UPDATE_CONTACT_NOTES'
export const FAILED_UPDATE_CONTACT_NOTES = 'FAILED_UPDATE_CONTACT_NOTES'

const schoolId = localStorage.getItem('schoolId')

import updateContactNotesCTRL from 'controllers/contactTimeline/updateContactNotes'

export function updateContactNotes(contactId, params, callback){
  return function(dispatch) {

    dispatch({
      type: START_UPDATE_CONTACT_NOTES,
      // payload: {updating: true, announcementInfo}
    })

    updateContactNotesCTRL(contactId, params)
    .then((result) => {
      dispatch({
        type: SUCCESS_UPDATE_CONTACT_NOTES,
        payload: {...result, updating: false}
      })

      if(typeof(callback) == 'function'){
        callback()
      }

    })
    .catch((err)  => {
      dispatch({
        type: FAILED_UPDATE_CONTACT_NOTES,
        payload: err
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/template/Docks/ContactInfo/ContactNotes/redux/actions/updateContactNotes.js